import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconKebapMenu48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="menu">
            <circle
                cx="24"
                cy="39"
                r="3"
                fill={props.fill || 'currentColor'}
            />
            <circle
                cx="24"
                cy="24"
                r="3"
                fill={props.fill || 'currentColor'}
            />
            <circle
                cx="24"
                cy="9"
                r="3"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconKebapMenu24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="menu">
            <circle
                cx="12"
                cy="19"
                r="2"
                fill={props.fill || 'currentColor'}
            />
            <circle
                cx="12"
                cy="12"
                r="2"
                fill={props.fill || 'currentColor'}
            />
            <circle
                cx="12"
                cy="5"
                r="2"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconKebapMenu16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="menu">
            <circle
                cx="8"
                cy="13"
                r="1"
                fill={props.fill || 'currentColor'}
            />
            <circle
                cx="8"
                cy="3"
                r="1"
                fill={props.fill || 'currentColor'}
            />
            <circle
                cx="8"
                cy="8"
                r="1"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
